$(document).ready(function() {
    $('.js-modal-answer-image').on('click', function() {
        $('.js-modal-answer-image').removeClass('answered');
        $(this).addClass('answered');
        $('.b-modal-answers').addClass('show');
        if ($('.js-modal-answer-image.answered').hasClass('b-modal-answers__item--correct')) {
	        $('.js-item-answer-correct').show();
	        $('.js-item-answer-wrong').hide();
        } else if ($('.js-modal-answer-image.answered').hasClass('b-modal-answers__item--wrong')) {
	        $('.js-item-answer-correct').hide();
	        $('.js-item-answer-wrong').show();
        }
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/game-one/game-answers-images.js